<template>
    
    <form @submit.prevent="formData" ref="formpage" :data-formaction="formaction" class="formcreate" aria-describedby="Create a Page" method="post">

        <div class="mb-3">
            <label :for="formaction === 'insert' ? 'page_title' : 'page_titleedit'" class="form-label">Title</label>
            <template v-if="formaction === 'insert'">
                <input type="text" @focusin="inputvalidation($event, 'page_title')" @focusout="inputvalidation($event, 'page_title')" maxlength="150" v-model="title" name="title" class="form-control page_title" id="page_title" aria-describedby="page title" placeholder="Inform the Page Title" required>
            </template>
            <template v-if="formaction === 'update'">
                <input type="text" @focusin="inputvalidation($event, 'page_titleedit')" @focusout="inputvalidation($event, 'page_titleedit')" maxlength="150" v-model="titleedit" name="title" class="form-control page_title" id="page_titleedit" aria-describedby="page title" placeholder="Inform the Page Title" required>
            </template>
        </div>

        <div class="mb-3">
            <label :for="formaction === 'insert' ? 'page_keywords' : 'page_keywordsedit'" class="form-label">Keywords</label>
            <br>
            <small>Separete Words only by comma</small>
            <template v-if="formaction === 'insert'">
                <input type="text" maxlength="300" v-model="keywords" @focusin="inputvalidation($event, 'page_keywords'), checkpercomma($event, 'page_keywords')" @focusout="inputvalidation($event, 'page_keywords'), checkpercomma($event, 'page_keywords')" name="keywords" class="form-control page_keywords" id="page_keywords" aria-describedby="page keywords" placeholder="Inform the Page Keywords" required>
            </template>
            <template v-if="formaction === 'update'">
                <input type="text" maxlength="300" v-model="keywordsedit" @focusin="inputvalidation($event, 'page_keywordsedit'), checkpercomma($event, 'page_keywordsedit')" @focusout="inputvalidation($event, 'page_keywordsedit'), checkpercomma($event, 'page_keywordsedit')" name="keywords" class="form-control page_keywords" id="page_keywordsedit" aria-describedby="page keywords" placeholder="Inform the Page Keywords" required>
            </template>
        </div>

        <div class="mb-3">
            <label :for="formaction === 'insert' ? 'page_description' : 'page_descriptionedit'" class="form-label">Description</label>
            <template v-if="formaction === 'insert'">
                <textarea class="form-control page_description" v-model="description" @focusin="inputvalidation($event, 'page_description')" @focusout="inputvalidation($event, 'page_description')" name="description" maxlength="300" id="page_description" rows="3" aria-describedby="page description" placeholder="Inform the Page Description" required></textarea>
            </template>
            <template v-if="formaction === 'update'">
                <textarea class="form-control page_description" v-model="descriptionedit" @focusin="inputvalidation($event, 'page_descriptionedit')" @focusout="inputvalidation($event, 'page_descriptionedit')" name="description" maxlength="300" id="page_descriptionedit" rows="3" aria-describedby="page description" placeholder="Inform the Page Description" required></textarea>
            </template>
        </div>

        <div class="mb-3">

            <div v-if="Object.values(pagetype).length > 0" id="pagetypeinput" class="pagetypeinput">

                <label for="pagetype" class="form-label">Type of Page</label>

                <select
                    class="form-select pagetypeselectlist" 
                    id="pagetype" 
                    aria-label="Choose the type of page"
                    v-model="typeofpage"
                    @click="disabledButton()"
                >
            
                    <!-- Default Option Selected -->
                    <option selected>Choose the page type</option>

                    <!-- Layout Update Routine -->
                    <option 
                        v-for="(val, index) in pagetype" 
                        :key="val.id" 
                        :value="val.type.toLowerCase()"
                        >
                        {{ val.type }}
                    </option>
                
                </select>

            </div>

        </div>
         
        <template v-if="formaction === 'insert'">
            <button type="submit" class="btn btn-primary float-end" :disabled="disabled">Submit</button>
        </template>
        <template v-if="formaction === 'update'">
            <button type="submit" class="btn btn-primary float-end" :disabled="disablededit">Submit</button>
        </template>

    </form>

</template>

<script>
    export default{
        name: 'FormPageElement',
        emits: ['form-data', 'disabled-button'],
        props:{

            inputvalidation:{
                type: Function,
                required: true
            },
            checkpercomma:{
                type: Function,
                required: true
            },
            disabled:{
                type: Boolean,
                required: false
            },
            disablededit:{
                type: Boolean,
                required: false
            },
            formaction:{
                type: String,
                required: true
            },
            edittitle:{
                type: String,
                required: false
            },
            editkeywords:{
                type: String,
                required: false
            },
            editdescription:{
                type: String,
                required: false
            },
            pageidedit:{
                type: Number,
                required: false
            },
            pagelist:{
                type: Array,
                required: false
            },
            pagereferid:{
                type: String,
                required: false
            },
            pagetype:{
                type: Array,
                required: true
            },
            edittypeofpage:{
                type: String,
                required: false
            },
            disabledbutton:{
                type: Function,
                required: false
            }

        },
        data: () => {

            return {

                title: '',
                keywords: '',
                description: '',
                typeofpage: '',
                titleedit: '',
                keywordsedit: '',
                descriptionedit: '',
                typeofpageedit: '',
                valuechange: {},
                disabledbuttonedit: ''

            }


        },
        mounted(){

            //console.log(this.typeofpageedit);
    
        },
        methods:{

            disabledButton(){

                return this.disabledbutton;

            },
            checkChangeDataBeforeUpdate(){

                //Get Values from Page List
                let currentPage = Object.values(this.pagelist).find((value, index) => index === parseInt(this.pagereferid));
                
                //Check values change
                for(let [index, value] of Object.entries(currentPage)){

                    //Check values by index
                    switch(index){

                        case 'title':

                            if(value !== this.titleedit.trim()){

                                this.valuechange.title = this.titleedit.trim();

                            }

                        break;

                        case 'keywords':

                            if(value !== this.keywordsedit.trim()){

                                this.valuechange.keywords = this.keywordsedit.trim();

                            }
                            
                        break;

                        case 'description':

                            if(value !== this.descriptionedit.trim()){

                                this.valuechange.description = this.descriptionedit.trim();

                            }
                            
                        break;

                        case 'type':

                            this.valuechange.type = this.typeofpage.trim();

                        break;

                    }

                }

                return this.valuechange;
                
            },
            formData(){

                //DataForm Object Structure
                let dataForm;

                //Data Form Structure for insert route
                if(this.formaction === 'insert'){

                    //Object Structure
                    dataForm = {
                        title: this.title.trim(),
                        keywords: this.keywords.trim(),
                        description: this.description.trim(),
                        type: this.typeofpage.trim(),
                        formaction: this.$refs.formpage.getAttribute('data-formaction')
                    };

                    //Clean Data
                    this.title = '';
                    this.keywords = '';
                    this.description = '';
                    this.typeofpage = '';

                }
               

                //Data Form Structure for update route
                if(this.formaction === 'update'){

                    //Object Structure
                    dataForm = this.checkChangeDataBeforeUpdate();
                    dataForm.id = this.pageidedit;
                    dataForm.formaction =  this.$refs.formpage.getAttribute('data-formaction');

                    console.log(dataForm);

                    //Clean Variable
                    this.valuechange = {};

                }

                //Send Data for Parent
                return this.$emit('form-data', dataForm);

            }

        },
        computed:{

            computedUpdateTitle(){

                return this.titleedit = this.edittitle;

            },
            computedUpdateKeywords(){

                return this.keywordsedit = this.editkeywords;

            },
            computedUpdateDescription(){

                return this.descriptionedit = this.editdescription;

            },
            computedPageType(){

                return this.typeofpage;

            },
            computedDisabledEdit(){

                return this.disablededit;

            },
            computedPageTypeEdit(){

                return this.typeofpage = this.edittypeofpage;

            },
            

        },
        watch:{

            computedUpdateTitle(){},
            computedUpdateKeywords(){},
            computedUpdateDescription(){},
            computedPageType(){},
            computedDisabledEdit(){},
            computedPageTypeEdit(){}

        },
        components:{

        }


    }


</script>